import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-item: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: green;
`;

export const Dashboard = () => {
  return (
    <Container>
      <h1>DASHBOARD</h1>
    </Container>
  );
};
